import pregnantornursing from './pregnantornursing.js';

//import  from './.js';


export default [
	pregnantornursing
];